<template>
  <v-app>
    <Navbar :voltar="true" app />
    <Sidebar />
    <v-main>
      <v-container class="container" fluid>
        <Breadcrumbs :items="items" />
        <v-row justify="center">
          <v-col cols="12" class="px-12">
            <v-card class="mx-auto content" max-width="1000" elevation="1">
              <v-toolbar color="#343F53">
                <v-card-title
                  class="headline font-weight-bold d-flex align-center justify-space-between px-4 w-100"
                >
                  <spam style="color: white">{{
                    showNovoColaborador
                      ? "Novo Colaborador"
                      : showEditColaborador
                      ? "Editar Colaborador"
                      : "Gerenciamento de Colaboradores"
                  }}</spam>
                  <v-btn
                    color="white"
                    small
                    class="mr-2"
                    style="font-weight: bold"
                    @click="showNovoColaborador = true"
                    v-if="!showNovoColaborador && !showEditColaborador"
                  >
                    ADICIONAR COLABORADOR
                    <v-icon class="ml-2" dark>mdi-plus-thick</v-icon>
                  </v-btn>
                </v-card-title>
              </v-toolbar>

              <v-card-text v-if="!showNovoColaborador && !showEditColaborador">
                <v-card class="pa-4" elevation="0" rounded="lg">
                  <v-row>
                    <v-col cols="6"></v-col>
                    <v-col cols="6" class="px-0 pb-0"
                      ><v-text-field
                        v-model="search"
                        label="Filtrar"
                        variant="outlined"
                        density="compact"
                        hide-details
                        prepend-inner-icon="mdi-magnify"
                        rounded="lg"
                        class="bg-white"
                    /></v-col>
                  </v-row>
                </v-card>
                <v-data-table
                  :headers="headers"
                  :items="filteredColaboradores"
                  items-per-page="10"
                  :loading="loading"
                  loading-text="Buscando..."
                  items-per-page-text="Colaboradores por página"
                  :pageText="'{0}-{1} de {2}'"
                  :sort-by="[{ key: 'id', order: 'desc' }]"
                >
                  <template #no-data>
                    <div class="text-center py-4 text-medium-emphasis">
                      Nenhum colaborador encontrado.
                    </div>
                  </template>
                  <template #item.ativo="{ item }">
                    <div class="d-flex flex-row flex-md-row my-4 align-center">
                      <v-chip
                        :color="item.ativo ? 'green' : 'red'"
                        class="text-white"
                        label
                        size="small"
                      >
                        {{ item.ativo ? "Ativo" : "Inativo" }}
                      </v-chip>
                    </div>
                  </template>
                  <template #item.action="{ item }">
                    <div class="d-flex flex-row flex-md-row my-4 align-center">
                      <v-btn
                        rounded="lg"
                        variant="text"
                        @click="editarColaborador(item)"
                        color="#343F53"
                      >
                        <v-icon size="24">mdi-pencil</v-icon>
                      </v-btn>
                    </div>
                  </template>
                </v-data-table>
              </v-card-text>
              <v-card-text v-if="showNovoColaborador || showEditColaborador">
                <v-form v-model="formValid" ref="form">
                  <v-row no-gutter>
                    <v-col cols="12" class="py-0">
                      <v-text-field
                        label="Nome"
                        outlined
                        color="#343F53"
                        class="mt-4 custom-text-field"
                        v-model="colaboradorForm.pessoa.nome"
                        :rules="nameRules"
                        :counter="100"
                        hide-details
                        required
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" class="py-0">
                      <v-text-field
                        label="Email/Usuário"
                        outlined
                        color="#343F53"
                        :disabled="showEditColaborador"
                        class="mt-4 custom-text-field"
                        v-model="colaboradorForm.username"
                        :rules="emailRules"
                        hide-details
                        required
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" class="py-0">
                      <v-text-field
                        label="Senha"
                        outlined
                        :disabled="showEditColaborador"
                        color="#343F53"
                        class="mt-4 custom-text-field"
                        v-model="colaboradorForm.password"
                        :rules="passwordRules"
                        :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
                        :type="showPassword ? 'text' : 'password'"
                        @click:append="showPassword = !showPassword"
                        hide-details
                        required
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" class="py-0">
                      <v-text-field
                        label="Telefone"
                        outlined
                        color="#343F53"
                        class="mt-4 custom-text-field"
                        v-model="colaboradorForm.pessoa.telefone"
                        v-mask="'(##) #####-####'"
                        :rules="phoneRules"
                        hide-details
                        required
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" class="py-0">
                      <v-switch
                        v-model="colaboradorForm.ativo"
                        :label="colaboradorForm.ativo ? 'Ativo' : 'Desativado'"
                        color="#343F53"
                      ></v-switch>
                    </v-col>
                    <v-col cols="12" class="pt-4 d-flex justify-end">
                      <v-btn
                        variant="outlined"
                        class="mr-2"
                        @click="showNovoColaborador = false; showEditColaborador = false; resetForm()"
                      >
                        Cancelar
                      </v-btn>
                      <v-btn
                        color="#343F53"
                        class="text-white"
                        @click="enviarColaborador"
                      >
                        {{ showEditColaborador ? 'Atualizar' : 'Salvar' }}
                        <v-icon class="ml-2">mdi-check</v-icon>
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-form>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    </v-main>
    <Footer />
  </v-app>
</template>

<script>
import { useToast } from "vue-toastification";
import Sidebar from "@/components/restrito/Sidebar.vue";
import Navbar from "@/components/restrito/Navbar.vue";
const toast = useToast();
import Footer from "./Footer.vue";
import { http } from "@/services/config";
import authHeader from "@/services/auth-header";
import { mask } from "vue-the-mask";
import Breadcrumbs from "@/components/utils/Breadcrumbs.vue";

export default {
  components: {
    Navbar,
    Sidebar,
    Footer, 
    Breadcrumbs,
  },
  directives: {
    mask,
  },
  name: "CriarColaborador",
  data() {
    return {
      items: [
        {
          title: "Início",
          disabled: false,
          href: "/admin/despedidas",
        },
        {
          title: "Gerenciamento de Colaboradores",
          disabled: true,
        },
      ],
      colaboradores: [],
      loading: false,
      formValid: false,
      showPassword: false,
      colaboradorIdEmEdicao: null,
      colaboradorForm: {
        username: "",
        password: "",
        pessoa: {
          nome: "",
          telefone: "",
        },
        ativo: true,
      },
      showNovoColaborador: false,
      showEditColaborador: false,
      search: "",
      headers: [
        { title: "Nome", key: "nome", align: "start", sortable: true },
        {
          title: "Status",
          key: "ativo",
          align: "start",
          sortable: true,
          width: "200",
        },
        {
          title: "Ações",
          key: "action",
          align: "center",
          sortable: false,
          width: "100",
        },
      ],
      nameRules: [
        (v) => !!v || "Nome é obrigatório",
        (v) =>
          (v && v.length <= 100) || "Nome deve ter no máximo 100 caracteres",
      ],
      emailRules: [
        (v) => !!v || "Email é obrigatório",
        (v) => /.+@.+\..+/.test(v) || "Email deve ser válido",
      ],
      passwordRules: [
        (v) => !!v || "Senha é obrigatória",
        (v) =>
          (v && v.length >= 6) || "A senha deve ter pelo menos 6 caracteres",
      ],
      phoneRules: [
        (v) => !!v || "Telefone é obrigatório",
        (v) => (v && v.length >= 14) || "Telefone inválido",
      ],
    };
  },
  mounted() {
    this.consultarColaboradores();
  },
  computed: {
    filteredColaboradores() {
      if (!this.search) return this.colaboradores;

      const searchLower = this.search.toLowerCase();
      return this.colaboradores.filter((item) => {
        return item.nome && item.nome.toLowerCase().includes(searchLower);
      });
    },
  },
  methods: {
    consultarColaboradores() {
      this.loading = true;
      http
        .get("/usuario/colaboradores", {
          headers: authHeader(),
        })
        .then((response) => {
          this.colaboradores = response.data;
          this.loading = false;
        })
        .catch((e) => {
          console.error("Erro ao consultar:", e);
          toast.error("Erro ao consultar colaboradores");
          this.loading = false;
        });
    },

    enviarColaborador() {
      if (!this.$refs.form.validate()) {
        toast.error("Preencha todos os campos obrigatórios corretamente");
        return;
      }
      if(this.showEditColaborador && this.colaboradorIdEmEdicao){
        this.atualizarColaborador(this.colaboradorIdEmEdicao);
      } else {
        this.criarColaborador();
      }
    },
    criarColaborador() {
      if (!this.$refs.form.validate()) {
        toast.error("Preencha todos os campos obrigatórios corretamente");
        return;
      }

      this.loading = true;
      
      // Preparar payload para criação
      const payload = {
        username: this.colaboradorForm.username,
        password: this.colaboradorForm.password,
        pessoa: {
          nome: this.colaboradorForm.pessoa.nome,
          telefone: this.colaboradorForm.pessoa.telefone.replace(/\D/g, ""), // Remove não-dígitos
        },
        ativo: this.colaboradorForm.ativo
      };

      http
        .post("/usuario/nova-pessoa-colaborador", payload, {
          headers: authHeader(),
        })
        .then((response) => {
          console.log(response);
          toast.success("Colaborador cadastrado com sucesso!");
          this.showNovoColaborador = false;
          this.resetForm();
          this.consultarColaboradores();
        })
        .catch((e) => {
          console.error("Erro ao cadastrar colaborador:", e);
          toast.error("Erro ao cadastrar colaborador. Tente novamente.");
        })
        .finally(() => {
          this.loading = false;
        });
    },

    resetForm() {
      this.$refs.form.reset();
      this.colaboradorIdEmEdicao = null;
      this.colaboradorForm = {
        username: "",
        password: "",
        pessoa: {
          nome: "",
          telefone: "",
        },
        ativo: true,
      };
    },
    atualizarColaborador(id) {
      this.loading = true;
      
      // Preparar payload para atualização
      const payload = {
        pessoa: {
          nome: this.colaboradorForm.pessoa.nome,
          telefone: this.colaboradorForm.pessoa.telefone.replace(/\D/g, ""), // Remove não-dígitos
        },
        ativo: this.colaboradorForm.ativo
      };
      
      http
        .put("/usuario/atualizar-colaborador/" + id, payload, {
          headers: authHeader(),
        })
        .then((response) => {
          console.log(response);
          toast.success("Colaborador atualizado com sucesso!");
          this.showEditColaborador = false;
          this.resetForm();
          this.consultarColaboradores();
        })
        .catch((e) => {
          console.error("Erro ao atualizar colaborador:", e);
          toast.error("Erro ao atualizar colaborador. Tente novamente.");
        })
        .finally(() => {
          this.loading = false;
        });
    },
    editarColaborador(item) {
      this.showEditColaborador = true;
      this.colaboradorForm.pessoa.nome = item.nome;
      this.colaboradorForm.pessoa.telefone = item.telefone;
      this.colaboradorForm.ativo = item.ativo;
      this.colaboradorForm.username = item.email || "";
      
      // Armazenar o ID do colaborador em edição
      if (item.id) {
        this.colaboradorIdEmEdicao = item.id;
      }
    },
  },
};
</script>

<style scoped>
.v-main {
  background-color: #f5f5f5;
}
.container {
  min-height: 78vh !important;
  padding-top: 2rem;
}

.custom-text-field {
  margin-bottom: 1rem;
}

.custom-file-input {
  margin-top: 1rem;
}

.search {
  margin-bottom: 1rem;
}

.bg-white {
  background-color: white;
}
</style>
